import React, { useEffect } from 'react';
import './Pagination.scss'



const Paginate = ({activePage, setActivePage, pageArray, noOfPages}) => {
    // useEffect(() => {
    //     console.log(activePage)
    //     console.log(pageArray)
    // }, [activePage, pageArray])

    return (
        <div className='pagination'>
            <div className="page-box active" onClick={() => {
                if(activePage > 1) {
                    setActivePage(prev=> prev - 1)
                } 
                }}>
                <i class="fas fa-angle-left"></i>
            </div>

            {activePage - 1  === pageArray.length - 1? 
                pageArray.filter(el => {
                    return el === activePage - 3
                    }).map(el => {
                        return (
                            <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                {el}
                            </div>
                        )
                })
                :
                ''
            }

            {activePage <= 2? pageArray.filter(el => {
                    return el ===  1
                    }).map(el => {
                        return (
                            <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                {el}
                            </div>
                        )
                    })
                    :
                    pageArray.filter(el => {
                        return el === activePage - 2
                        }).map(el => {
                            return (
                                <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                    {el}
                                </div>
                            )
                    })
                }

                {activePage <= 2? pageArray.filter(el => {
                    return el ===  2
                    }).map(el => {
                        return (
                            <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                {el}
                            </div>
                        )
                    })
                    :
                    pageArray.filter(el => {
                        return el === activePage - 1
                        }).map(el => {
                            return (
                                <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                    {el}
                                </div>
                            )
                        })
                }

                {activePage <= 2? pageArray.filter(el => {
                    return el ===  3
                    }).map(el => {
                        return (
                            <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                    {el}
                                </div>
                        )
                    })
                    :
                    pageArray.filter(el => {
                        return el === activePage
                        }).map(el => {
                            return (
                                <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                                    {el}
                                </div>
                            )
                        })
                }


                {pageArray.length <= 3? '' : activePage >= pageArray.length? '' :
                    <div className={`page-box page${pageArray.length}`} key={pageArray.length} onClick={() => setActivePage(pageArray.length)}>
                        {pageArray.length}
                    </div>
                }

            {/* {pageArray.map(el => {
                return (
                <div className={`page-box page${el}`} key={el} onClick={() => setActivePage(el)}>
                    {el}
                </div>
                )
            })} */}

            <div className="page-box" onClick={() => {
                if(activePage < noOfPages) {
                    setActivePage(prev=> prev + 1)
                } 
                }}>
                <i class="fas fa-angle-right"></i>
            </div>
        </div>
    )
}

export default Paginate